<template>
  <bubble-menu
    :editor="editor"
    :tippy-options="{ duration: 100 }"
    v-if="mounted && editor && editable"
  >
    <button
      @click="editor.chain().focus().toggleBold().run()"
      :class="{ 'is-active': editor.isActive('bold') }"
    >
      bold
    </button>
    <button
      @click="editor.chain().focus().toggleItalic().run()"
      :class="{ 'is-active': editor.isActive('italic') }"
    >
      italic
    </button>
    <button
      @click="editor.chain().focus().toggleStrike().run()"
      :class="{ 'is-active': editor.isActive('strike') }"
    >
      strike
    </button>
    <button
      v-if="editor.isActive('link')"
      @click="editor.chain().focus().unsetLink().run()"
    >
      Unlink
    </button>
    <button v-else @click="editor.chain().focus().setLink({ href: '#' }).run()">
      Link
    </button>
    <input v-if="editor.isActive('link')" v-model="link" />
  </bubble-menu>
  <div
    v-if="!mounted && props.modelValue"
    class="tiptap"
    v-html="generateHTML(props.modelValue, extensions)"
  />
  <editor-content v-else :editor="editor" />
</template>

<script setup lang="ts">
import { useEditor, EditorContent, BubbleMenu } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import { generateHTML } from "@tiptap/html";
import Image, { useHandleDrop } from "@/nodes/Image";

const extensions = [
  StarterKit,
  Image,
  Link.configure({
    openOnClick: false,
  }),
];

const props = defineProps({
  editable: {
    type: Boolean,
  },
  modelValue: {
    type: Object as PropType<any>,
  },
});

const link = computed({
  get() {
    if (!editor.value?.isActive("link")) return "";
    return editor.value.getAttributes("link").href;
  },
  set(value: string) {
    editor.value?.chain().setLink({ href: value }).run();
  },
});

const emit = defineEmits(["update:modelValue"]);
const mounted = ref(false);
onMounted(() => (mounted.value = true));
const handleDrop = useHandleDrop();

const lastVersion = ref();

const editor = useEditor({
  content: props.modelValue,
  extensions,
  editable: props.editable,
  editorProps: {
    handleDrop,
  },
  onUpdate: () => {
    lastVersion.value = editor.value?.getJSON();
    emit("update:modelValue", lastVersion.value);
  },
});

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue === lastVersion.value) return;

    console.log(
      "Updated modelValue",
      props.modelValue,
      lastVersion.value,
      props.modelValue === lastVersion.value
    );
    editor.value?.commands.setContent(props.modelValue);
  }
);
</script>
